export const payFormPatch = (contentWindow) => {
  const interval = setInterval(() => {
    const document = contentWindow.document;
    const checkbox = document.querySelector(
      '.smgl-Checkbox__container',
    ) as HTMLDivElement;
    if (checkbox) {
      checkbox.click();
      clearInterval(interval);
      checkbox.style.display = 'none';
    }
  }, 10);
};
